function eventFire(el, etype){

  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    console.log(evObj);
    el.dispatchEvent(evObj);
  }
}
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
     this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
       var selectId= $('.select-1').attr('id');
  if($(this).attr('data-type') == 'sample'){
    $(this).addClass('hello');
    var vTitle= $('.sample_button',this).attr('data-variant-title');
    $('#'+selectId+' option').removeAttr('selected');
    $("select.select-1 option[data-value='"+vTitle+"']").attr('selected','selected');
    eventFire(document.getElementById(selectId), 'change');
  }else if($('.sample_button').length > 0){
     var sel_variant=$('#'+selectId).next('.scrollableList').find('.selectedOption').attr('data-selected_option_val');
   $('#'+selectId+' option').removeAttr('selected');
     $("select.select-1 option[data-value='"+sel_variant+"']").attr('selected','selected');
   eventFire(document.getElementById(selectId), 'change');
  }
       
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
    if($(this).attr('data-type') == 'sample'){
      $('.sample_button',this).addClass('loading');
       $('.sample_button .loading-overlay__spinner',this).removeClass('hidden');
       $('.sample_button',this).attr('aria-disabled', true);
    }else{
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
           setTimeout(() => {
    const btn = document.getElementById('main_add');
    if (btn) {
      btn.disabled = false;
      btn.querySelector('span').textContent = 'Add to cart';
    }
  }, 100);
// $("#ctm-checkout_jtpl").click(function(){
//   $(".checkout-popup").addClass('checkout_model-open');
// });

// $(".checkout_popup-close-btn").click(function(){
//   $(".checkout-popup").removeClass('checkout_model-open');
//   $('#CartDrawer-Checkout').show();
//   $('#ctm-checkout_jtpl').hide();
//  setCookie('checkout_popup', 'true', 1);
// });
//   $('.checkout_no-thanks-btn').click(function(){
//     $('.checkout-popup').removeClass('checkout_model-open');
//     $('#CartDrawer-Checkout').show();
//     $('#ctm-checkout_jtpl').hide();
//     setCookie('checkout_popup', 'true', 1);

// });

// if(getCookie('checkout_popup') == 'true' ){
//    $('.checkout-popup').removeClass('checkout_model-open');
//     $('#CartDrawer-Checkout').show();
//     $('#ctm-checkout_jtpl').hide();

// }
           if($(this).attr('data-type') == 'sample'){
      $('.sample_button',this).removeClass('loading');
       $('.sample_button .loading-overlay__spinner',this).addClass('hidden');
       $('.sample_button',this).attr('aria-disabled', false);
         if($('.product-form__input[data-type="true"] select').length >0){      
       $(".product-form__input[data-type=true] select option").removeAttr("selected");
      $('.product-form__input[data-type=true] select option[value="main"]').attr("selected", "selected");
       var selectId = $('.product-form__input[data-type=true] select').attr('id');
         eventFire(document.getElementById(selectId), 'change');
         }else{
             $(".product-form__input[data-type='true'] input[value='main']").trigger('click');
            }   
if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    }else{
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
           }    
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
